export const createLicenseCodes = {
    en: {
        cl200: 'License pack created successfully',
        cl404: 'Team does not exist',
        cl403: 'Admin not authorized to create license packs',
    },
    pt: {
        cl200: 'Pacote de licença criado com sucesso',
        cl404: 'Time não existe',
        cl403: 'Admin não autorizado a criar pacotes de licença',
    },
    es: {
        cl200: 'Paquete de licencias creado con éxito',
        cl404: 'El equipo no existe',
        cl403: 'Administrador no autorizado para crear paquetes de licencias',
    },
    fr: {
        cl200: 'Pack de licences créé avec succès',
        cl404: 'L\'équipe n\'existe pas',
        cl403: 'Administrateur non autorisé à créer des packs de licences',
    }
};

export const expireLicenseCodes = {
    en: {
        el200: 'License pack modified successfully',
        el404: 'Team does not exist',
        el403: 'Admin not authorized to expire/modify license packs',
    },
    pt: {
        el200: 'Pacote de licença modificado com sucesso',
        el404: 'Time não existe',
        cl403: 'Admin não autorizado a expirar pacotes de licença',
    },
    es: {
        el200: 'Paquete de licencias modificado con éxito',
        el404: 'El equipo no existe',
        el403: 'Administrador no autorizado para expirar paquetes de licencias',
    },
    fr: {
        el200: 'Pack de licences modifié avec succès',
        el404: 'L\'équipe n\'existe pas',
        el403: 'Administrateur non autorisé à expirer/modifier les packs de licences',
    }
};

export const deleteLicenseCodes = {
    en: {
        dl422: 'License pack still has an active Stripe subscription; cancel it first',
        dl200: 'License pack deleted successfully',
        dl400: 'License pack does not exist',
        dl403: 'Admin not authorized to delete license packs',
        dl409: 'License pack still has users assigned',
    },
    pt: {
        dl422: 'O pacote de licença ainda tem uma assinatura Stripe ativa; cancele-a primeiro',
        dl200: 'Pacote de licença excluído com sucesso',
        dl400: 'Pacote de licença não existe',
        dl403: 'Admin não autorizado a excluir pacotes de licença',
        dl409: 'O pacote de licença ainda tem usuários atribuídos',
    },
    es: {
        dl422: 'El paquete de licencias aún tiene una suscripción de Stripe activa; cancélela primero',
        dl200: 'Paquete de licencias eliminado con éxito',
        dl400: 'El paquete de licencias no existe',
        dl403: 'Administrador no autorizado para eliminar paquetes de licencias',
        dl409: 'El paquete de licencias aún tiene usuarios asignados',
    },
    fr: {
        dl422: 'Le pack de licences a encore un abonnement Stripe actif ; annulez-le d\'abord',
        dl200: 'Pack de licences supprimé avec succès',
        dl400: 'Le pack de licences n\'existe pas',
        dl403: 'Administrateur non autorisé à supprimer les packs de licences',
        dl409: 'Le pack de licences a encore des utilisateurs assignés',
    }
};
